export interface Rating {
  qualification: string;
  rate_reason?: string;
  disatisfaction_reason?: string;
}
